module.exports = __webpack_public_path__ + "static/media/feuilles.1d78293c.png";